import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentFlowButtonComponent } from 'app/modules/shared/document-flow-button/document-flow-button.component';

/**
 * Actions Cell Renderer
 *
 * Renders action menu with document flow button
 *
 * @example
 * ```typescript
 * {
 *   headerName: 'Acciones',
 *   cellRenderer: ActionsCellRendererComponent,
 *   sortable: false,
 *   minWidth: 100,
 *   colId: 'actions'
 * }
 * ```
 */
@Component({
  selector: 'app-actions-cell-renderer',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    DocumentFlowButtonComponent,
  ],
  template: `
    <button
      mat-icon-button
      [matMenuTriggerFor]="actionMenu"
      matTooltip="Acciones"
      (click)="$event.stopPropagation()">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #actionMenu="matMenu">
      <app-document-flow-button [element]="params.data"></app-document-flow-button>
    </mat-menu>
  `,
})
export class ActionsCellRendererComponent implements CellRenderer<OrderDetailAttributes> {
  @Input() params!: CellRendererParams<OrderDetailAttributes>;
}
